import {useCallback} from 'react';

import {noop} from 'shared/web';

import {GridApi} from '../types/AgGridTypes';

export const useRefreshCells = (gridApi?: GridApi) =>
  useCallback(() => (gridApi ? gridApi.refreshCells.bind(gridApi) : noop), [gridApi]);
